import React from "react";
import { connect } from "react-redux";
import { FiArrowDown } from "react-icons/fi";

import Loader from "../components/Loader";
import NewSuggestion from "../components/Suggestions/New";
import SuggestionOverview from "../components/Suggestions/Overview";
import isBrowser from "../utils/isBrowser";

const Feedback = ({ me, org }) => {
    const [ processing, setProcessing ] = React.useState(false);
    const [ success, setSuccess ] = React.useState(undefined);
    const [ nextPage, setNextPage ] = React.useState(1);
    const [ more, setMore ] = React.useState(true);

    const [ feedback, setFeedback ] = React.useState([]);

    React.useEffect(() => {
        if (!org || !org._id) return;

        if (!isBrowser()) return;

        window.fetch(process.env.API_URL + "/orgs/" + org._id + "/feedback", {
            headers: {
                Accept: "application/json",
                Authorization: me.token,
            },
        }).then(res => {
            if (res.ok) return res.json();
            throw new Error(res.statusText);
        }).then(feedback => {
            setSuccess(true);
            setFeedback(feedback);
        }).catch((e) => {
            console.error(e);
            setSuccess(false);
        });
    }, [ me.token, org ]);

    const loadMore = () => {
        if (!more) return;

        setMore(undefined);

        if (!isBrowser()) return;

        window.fetch(process.env.API_URL + "/orgs/" + org._id + "/feedback?page=" + nextPage, {
            headers: {
                Accept: "application/json",
                Authorization: me.token,
            },
        }).then(res => {
            if (res.ok) return res.json();
            throw new Error(res.statusText);
        }).then(newFeedback => {
            if (newFeedback.length === 25) {
                setMore(true);
            } else {
                setMore(false);
            }
            setNextPage(nextPage + 1);
            setFeedback(feedback.concat(newFeedback));
        }).catch((e) => {
            console.error(e);
            setMore(true);
        });
    };

    const updateFeedback = (newFeedback) => {
        if (!newFeedback) return;

        setFeedback([ newFeedback, ...feedback ]);
    };

    const updateVote = (f, vote) => {
        if (processing) return;

        setProcessing(true);

        if (!isBrowser()) return;

        window.fetch(process.env.API_URL + "/orgs/" + org._id + "/feedback/" + f._id + "/vote", {
            method: "PATCH",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": me.token,
            },
            body: JSON.stringify({
                vote,
            }),
        }).then(res => {
            if (res.ok) return res.json();
            throw new Error(res.statusText);
        }).then(updatedFeedback => {
            const newFeedback = feedback;
            const index = newFeedback.find(f => f._id === updatedFeedback._id);
            newFeedback.splice(index, 1, updatedFeedback);

            setProcessing(false);
            setFeedback(newFeedback);
        }).catch((e) => {
            console.error(e);
            setProcessing(false);
        });
    }

    return (
        <div css={{
            display: "flex",
            flexWrap: "wrap",
            flexDirection: "row-reverse",
        }}>
            <div css={{
                flex: 1,
                minWidth: 250,
            }}>
                <NewSuggestion onCreate={ updateFeedback } />
            </div>

            <div css={{
                flex: 2,
                minWidth: 300,
            }}>
                {
                    success === true
                    ?   <>
                            {
                                feedback.length
                                ?   feedback.map(feedback =>
                                        <SuggestionOverview
                                            key={ feedback._id }
                                            code={ org.code }
                                            id={ feedback._id }
                                            title={ feedback.title }
                                            details={ feedback.details }
                                            upvotes={ feedback.upvotes && feedback.upvotes instanceof Array && feedback.upvotes.length }
                                            downvotes={ feedback.downvotes && feedback.downvotes instanceof Array && feedback.downvotes.length }
                                            upvoted={ me && me.id && feedback.upvotes && feedback.upvotes instanceof Array && feedback.upvotes.includes(me.id.toString()) }
                                            downvoted={ me && me.id && feedback.downvotes && feedback.downvotes instanceof Array && feedback.downvotes.includes(me.id.toString()) }
                                            closedAt={ feedback.closedAt }
                                            handleVote={ vote => updateVote(feedback, vote) }
                                            authenticated={ me && me.token }
                                        />
                                    )
                                :   <div css={{
                                        display: "flex",
                                        alignItems: "center",
                                        color: "darkgrey",
                                        padding: 20,
                                    }}>
                                        It's so empty and cold over here! Create a post and it'll show up here.
                                    </div>
                            }
                        </>
                    :   success === false
                        ?   <div css={{ fontSize: ".8em", color: "darkgrey", padding: 20 }}>Oh, crap! Our servers having some issues. Please try again.</div>
                        :   <div css={{ padding: "10px 20px" }}><Loader /></div>
                }

                {
                    feedback.length && more !== false
                    ?   <div
                            css={{
                                padding: 25,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "grey",
                                transition: "color var(--transition-default-time) ease, transform var(--transition-default-time) ease",
                                cursor: "wait",
                                ":hover": {
                                    color: "var(--light)",
                                },
                                ":hover div": {
                                    transform: "translateY(5px)",
                                },
                                ":hover svg": {
                                    transform: "translateY(15px)",
                                },
                            }}
                            onMouseOver={ loadMore }
                            onFocus={ loadMore }
                        >
                            <div css={{
                                transition: "transform var(--transition-default-time) ease-out",
                            }}>
                                {
                                    more === true
                                    ?   "Load More"
                                    :   "Loading"
                                }
                            </div>
                            <FiArrowDown
                                css={{
                                    transition: "transform var(--transition-default-time) ease-out",
                                }}
                            />
                        </div>
                    :   null
                }
            </div>
        </div>
    );
};

export default connect(
    state => ({ me: state.global.me, org: state.global.org }),
    null,
)(Feedback);
